export enum EmployerEmploymentType {
  OnlyFullTime = 'only_fulltime',
  OnlyPartTime = 'only_parttime',
  OnlyMarginal = 'only_marginal',
  HkOnlyFullTime = 'hk_only_fulltime',
}
export const EMPLOYER_EMPLOYMENT_TYPE_TRANSLATIONS: Record<EmployerEmploymentType, string> = {
  [EmployerEmploymentType.OnlyFullTime]: 'Nur Vollzeit',
  [EmployerEmploymentType.OnlyPartTime]: 'Nur Teilzeit',
  [EmployerEmploymentType.OnlyMarginal]: 'Nur Geringfügig',
  [EmployerEmploymentType.HkOnlyFullTime]: 'HK nur Teilzeit',
};
